import { useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "redux-share";
import { handleContinuousPlayback } from "ui/src/playerComponents/continuousPlayback/continuousePlayback";
import { conditions, continuousePlaybackIntervalTime } from "..";
import { ConditionName } from "interfaces";

const useContinuousPlaybackInterval = () => {
    let interval: any = null;

    const { isEnded } = useAppSelector(({ controller: { isEnded } }) => ({ isEnded }), shallowEqual);

    useEffect(() => {
        interval = setInterval(() => handleContinuousPlayback(), continuousePlaybackIntervalTime);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (conditions(ConditionName.isEnded)) clearInterval(interval);
    }, [isEnded]);
};

export default useContinuousPlaybackInterval;
